// vjs-player.component.ts
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import videojs from 'video.js';

@Component({
    selector: 'app-vjs-player',
    template: '<video #target  class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" controls preload="auto"></video>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VjsPlayerComponent implements OnInit, OnDestroy {
    @ViewChild('target', { static: true }) target: ElementRef;
    @Input() options: {
        controls: boolean,
        fluid: boolean,
        aspectRatio: string,
        autoplay: any,
        sources: {
            src: string,
            type: string,
        }[],
    };
    player: videojs.Player;

    constructor(
        private elementRef: ElementRef,
    ) { }

    ngOnInit() {
        this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() {
            
        });
    }

    ngOnDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    }
}